import React from "react";
import Box from "@mui/material/Box";
import dischargeInstructionsLogo from "../../../assets/images/logos/discharge-instructions-logo.png";

const DischargeInstructionsDashboardLogo = ({ height, maxWidth, sx }) => (
  <Box
    component="img"
    src={dischargeInstructionsLogo}
    alt="Discharge Instructions"
    sx={{
      display: "block",
      height: height ?? "auto",
      width: "auto",
      maxWidth: maxWidth ?? "100%",
      ...sx,
    }}
  />
);

export default DischargeInstructionsDashboardLogo;
